export default __webpack_public_path__ + "static/media/logo.60a7bb56.svg";